import { InjectionToken } from '@angular/core';
import { IAcsHttpService } from './acs/acs-http-service.interface';
import { IAuthHttpService } from './auth/auth-http-service.interface';

export const ACS_HTTP_SERVICE = new InjectionToken<IAcsHttpService>('ACS_HTTP_SERVICE');
export const AUTH_HTTP_SERVICE = new InjectionToken<IAuthHttpService>('AUTH_HTTP_SERVICE');
